import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch (e) {
        if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login") && window.location.pathname.startsWith("/app")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e, fallback = "Ein Fehler ist aufgetreten") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
}

export const eur = (v) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(v) || 0);

export const deDate = (s) => {
  if (!s) return "–";
  try {
    return new Date(s).toLocaleDateString("de-DE");
  } catch {
    return s;
  }
};
